export const getEnumKey = (enumObj: any, enumValue: string) => {
  return Object.keys(enumObj).find((key) => enumObj[key] === enumValue);
};
